/**
 * Copy under the Detail Book CTA.
 *
 * CP-144: the ON state no longer uses BOOK_THROUGH_OUR_LINKS (kept exported for
 * honesty tests). The CruiseDirect commission sentence is only true when the button is a
 * live affiliate link. Affiliate OFF, a missing partner URL, or the disabled
 * "Booking Not Available" control must not claim shoppers can book through
 * our links. The not-configured note is the existing CP-50 sentence.
 */

export const BOOK_THROUGH_OUR_LINKS =
  'When you book through our links, Cruise Signals may earn an affiliate commission at no extra cost to you.';

export const NOT_CONFIGURED_NOTE =
  "Direct online booking is not available on this site. Check the cruise line's website to book.";

export function isBookableAffiliateLink(affiliateEnabled, partnerUrl) {
  return Boolean(affiliateEnabled) && Boolean(partnerUrl);
}

export function bookingDisclosureCopy({
  affiliateEnabled = false,
  partnerUrl = null,
  partnerName = 'CruiseDirect',
} = {}) {
  if (!isBookableAffiliateLink(affiliateEnabled, partnerUrl)) {
    return {
      bookable: false,
      note: NOT_CONFIGURED_NOTE,
      partnerDisclosure: null,
    };
  }
  return {
    bookable: true,
    note: null,
    // CP-144 (PO): the legacy partner/direct-bookings handshake line (and the
    // book-through-links claim) is gone; ON keeps only the CP-143 copy plus this short
    // commission line (same wording as the deal cards).
    partnerDisclosure: `Partner link to ${partnerName}. We may earn a commission.`,
  };
}
